var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo-viewer"},[_c('viewer',{attrs:{"images":_vm.images,"options":_vm.options},on:{"inited":_vm.inited}},_vm._l((_vm.images),function(src,index){return _c('img',{key:index,ref:"viewer",refInFor:true,staticStyle:{"opacity":"0","display":"none"},attrs:{"src":src}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }